/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { formatDate } from "../../../services/helpers/articles";
import { getReportArticles } from "../../../services/redux/articles/report/reducer";
import Section from "../../blocks/Section/Section";
import { Article } from "../Article/Article";
import "./Sections.scss";

const ReportSection = ({ articles, getReportArticles, customArticles, t }) => {
  useEffect(() => {
    if (articles.count === -1 && customArticles === undefined) {
      getReportArticles(1, {}, 3);
    }
  }, []);

  const articlesList = customArticles || articles.results || [];

  return (
    <Section
      title={
        <h2>
          {t("widgets:report.title")}{" "}
          <a className="Sections__more" href="#">
            {t("widgets:report.allArticles")}
          </a>
        </h2>
      }
    >
      <div className="Sections__articles">
        {articlesList.slice(0, 3).map(item => (
          <Article
            className="sideArticle sideArticle--solid"
            key={item.id}
            id={item.id}
            src={item.thumb !== null ? item.thumb.file : ""}
            date={formatDate(item.published_at)}
            tags={item.tags}
            category={item.article_type}
            summary={item.summary}
            articleTitle={item.name}
            articleText={item.content}
            articlesTags={item.articlesTags}
            slug={item.slug}
            access={item.access}
            video={!!item.video_url}
          />
        ))}
      </div>
    </Section>
  );
};

ReportSection.defaultProps = {
  title: "Co nowego w Agroraporcie?",
  link: "Wszystkie materiały",
};

export default connect(
  state => ({
    articles: state.articles.report,
  }),
  {
    getReportArticles,
  }
)(withTranslation(["widgets"])(ReportSection));
